import {ListFilterTrigger} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {PayoutsFilterMenu} from './PayoutsFilterMenu';
import {countPayoutsActiveFilters} from './utils/payouts-filter.utils';

import type {PayoutsFilterState} from './config/payouts-filter.config';
import type {FC} from 'react';

export interface PayoutsFilterProps {
  filter: PayoutsFilterState;
  onChange: (filter: PayoutsFilterState) => void;
  disabled?: boolean;
}

export const PayoutsFilter: FC<PayoutsFilterProps> = ({filter, onChange, disabled = false}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ListFilterTrigger
      buttonLabel={t('view.payouts.list.filter.button')}
      activeCount={countPayoutsActiveFilters(filter)}
      disabled={disabled}
    >
      <PayoutsFilterMenu filter={filter} onChange={onChange} />
    </ListFilterTrigger>
  );
};
